export enum ESortDir {
  ASC = 'asc',
  DESC = 'desc',
}

export const DEFAULT_SORT_DIR = ESortDir.ASC

export enum ERowView {
  expand = 'expand',
  crop = 'crop',
}

export enum EKanbanKeys {
  finishType = 'finish_type',
  target = 'target',
  userName = 'user_name',
  scriptName = 'script_name'
}

export enum ETableView {
  table = 'table',
  kanban = 'kanban'
}

export const KANBAN_FIELDS = ['target', 'user_name', 'finish_type', 'instance_name']


export const MAX_RECORDS_DURATION = 18000
export const DATA_TABLE_SELECT_VALUES = [10, 20, 50]
export const DEFAULT_ITEMS_ON_PAGE = 20
export const RECORD_INFO_ITEMS = ['record', 'history']
export const DATE_FILTER_TYPE = ['none', 'single', 'range']

export const FILTER_SELECTS = [
  { name: 'equals', symbol: 'E', type: 'string', input: 'text' },
  { name: 'notEquals', symbol: '!E', type: 'string', input: 'text' },
  { name: 'contains', symbol: 'C', type: 'string', input: 'text' },
  { name: 'notContains', symbol: '!C', type: 'string', input: 'text' },
  { name: 'headIs', symbol: 'H', type: 'string', input: 'text' },
  { name: 'tailIs', symbol: 'T', type: 'string', input: 'text' },
  { name: 'empty', symbol: 'B', type: 'string', input: 'none' },
  { name: 'notEmpty', symbol: '!B', type: 'string', input: 'none' },

  { name: 'equals', symbol: 'E', type: 'bool', input: 'select' },
  { name: 'notEquals', symbol: '!E', type: 'bool', input: 'select' },

  {
    name: 'equals',
    symbol: 'E',
    type: 'user_id',
    input: 'userNameMultiselect',
  },
  {
    name: 'notEquals',
    symbol: '!E',
    type: 'user_id',
    input: 'userNameMultiselect',
  },

  {
    name: 'equals',
    symbol: 'E',
    type: 'script_id',
    input: 'titleMultiselect',
  },
  {
    name: 'notEquals',
    symbol: '!E',
    type: 'script_id',
    input: 'titleMultiselect',
  },

  {
    name: 'equals',
    symbol: 'E',
    type: 'finish_type',
    input: 'finishTypeMultiselect',
  },
  {
    name: 'notEquals',
    symbol: '!E',
    type: 'finish_type',
    input: 'finishTypeMultiselect',
  },

  { name: 'numberEquals', symbol: 'E', type: 'number', input: 'time' },
  { name: 'numberNotEquals', symbol: '!E', type: 'number', input: 'time' },
  { name: 'numberLessThan', symbol: 'L', type: 'number', input: 'time' },
  {
    name: 'numberLessThanOrEquals',
    symbol: '!G',
    type: 'number',
    input: 'time',
  },
  { name: 'numberGreaterThan', symbol: 'G', type: 'number', input: 'time' },
  {
    name: 'numberGreaterThanOrEquals',
    symbol: '!L',
    type: 'number',
    input: 'time',
  },
  { name: 'between', symbol: 'A', type: 'number', input: 'betweenTime' },
  { name: 'notBetween', symbol: '!A', type: 'number', input: 'betweenTime' },
  { name: 'empty', symbol: 'B', type: 'number', input: 'none' },
  { name: 'notEmpty', symbol: '!B', type: 'number', input: 'none' },

  { name: 'on', symbol: 'D', type: 'date', input: 'date' },
  // { name: 'inLast', symbol: '!E', type: 'date', input: 'date' }, // dont work
  // { name: 'dueIn', symbol: 'C', type: 'date', input: 'date' }, // dont work
  // { name: 'lessThan', symbol: 'L', type: 'date', input: 'date' },
  // { name: 'greaterThan', symbol: 'G', type: 'date', input: 'date' },
  { name: 'between', symbol: 'A', type: 'date', input: 'betweenDate' },
  { name: 'today', symbol: 'Dnow', type: 'date', input: 'none' },
  { name: 'yesterday', symbol: 'Dprevious', type: 'date', input: 'none' },
  { name: 'tomorrow', symbol: 'Dnext', type: 'date', input: 'none' },

  { name: 'thisWeek', symbol: 'Wnow', type: 'date', input: 'none' },
  { name: 'lastWeek', symbol: 'Wprevious', type: 'date', input: 'none' },
  { name: 'nextWeek', symbol: 'Wnext', type: 'date', input: 'none' },

  { name: 'thisMonth', symbol: 'Mnow', type: 'date', input: 'none' },
  { name: 'lastMonth', symbol: 'Mprevious', type: 'date', input: 'none' },
  { name: 'nextMonth', symbol: 'Mnext', type: 'date', input: 'none' },

  { name: 'empty', symbol: 'B', type: 'date', input: 'none' },
  { name: 'notEmpty', symbol: '!B', type: 'date', input: 'none' },
]

export const CORRECT_QUERY = ['filter']

export const WATCHED_QUERY = [
  'limit',
  'offset',
  'expand',
  'sort',
  'filter',
  'columns',
]

export const DELETED_COLUMNS = ['user_name', 'title', 'instance_id']
export const RENAMED_COLUMNS = ['user_id', 'script_id']

export const KANBAN_RENAMED_COLUMNS = {
  ['user_name']: 'user_id',
  ['script_name']: 'script_id'
}

export const FINISH_TYPE = [
  { id: 1, name: 'idle' },
  { id: 2, name: 'terminated' },
  { id: 3, name: 'switched' },
  { id: 4, name: 'timedOut' },
  { id: 5, name: 'unpublished' },
  { id: 6, name: 'deleted' },
]

export const HIDE_COLUMNS = {
  records: ['user_id', 'instance_id'],
  billing: ['product_id', 'quantity', 'id']
}
